import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const checkoutGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  if (state.url.includes('checkout')) {
    let routeName = route.parent?.paramMap.get('routeName');
    const items = localStorage.getItem(`cart_${routeName}`);

    let parsedItems: any[] = [];
    try {
      parsedItems = items ? JSON.parse(items) : [];
    } catch {
      parsedItems = [];
    }

    const hasItems = parsedItems.length > 0;
    if (!hasItems && routeName) {
      router.navigate([`/u/${routeName}/home`]);
      return false;
    }
  }

  return true;
};
